
import { FetchAPI_template } from "./FetchAPI_template";


export const GetServices = async() => {


    const params = new URLSearchParams({
        project_id: process.env.REACT_APP_PROJECT_ID,
    }).toString();

    const url = `${process.env.REACT_APP_SERVER}api/v1/client/services/get?${params}`;

    const method = "GET";
    
    const fetch_api_request = await FetchAPI_template(url,method);

    return fetch_api_request;
    
}

export const RemoveService = async(data,token) => {

    const url = `${process.env.REACT_APP_SERVER}api/v1/user/services/remove`;

    const method = "POST";
    
    const fetch_api_request = await FetchAPI_template(url,method,data,token);

    return fetch_api_request;
    
}


export const CreateNewService = async(data, token) => {

    const url = `${process.env.REACT_APP_SERVER}api/v1/user/services/new`;

    const method = "POST";
    
    const fetch_api_request = await FetchAPI_template(url,method,data,token);

    return fetch_api_request;
}
